import { defineComponent as _defineComponent } from 'vue'
import { useLineStore } from "@/stores/lineStore";
import { useServiceStore } from "@/stores/serviceStore";
import { useUserStore } from "@/stores/userStore";
import { BoardCheckCode, BookRequiredType, RouterName } from "@/types";
import { computed } from "vue";


const __default__ = {
  name: "UtilityButton",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props, { expose: __expose }) {
  __expose();

const lineStore = useLineStore();
const userStore = useUserStore();
const serviceStore = useServiceStore();

const serviceInfo = computed(() => serviceStore.serviceInfo);
const userInfo = computed(() => userStore.userInfo);
const bookRequiredType = computed(() => lineStore.getBookRequiredType());

const ticketBtnLabel = computed(() => {
  if (bookRequiredType.value === BookRequiredType.BOOK_REQUIRED) {
    return "예약내역 화면으로 이동";
  } else if (bookRequiredType.value === BookRequiredType.MIXED) {
    return "탑승현황 화면으로 이동";
  } else {
    return "";
  }
});

const __returned__ = { lineStore, userStore, serviceStore, serviceInfo, userInfo, bookRequiredType, ticketBtnLabel, get BoardCheckCode() { return BoardCheckCode }, get BookRequiredType() { return BookRequiredType }, get RouterName() { return RouterName } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})